import { getApiConfig } from "@/config/api.config";
import { BaseApiService } from "@/services/api/BaseApiService";

interface FeedbackPayload {
  storeId: number;
  subject: string;
  message: string;
}

export class FeedbackService extends BaseApiService {
  private static instance: FeedbackService;

  private constructor() {
    super();
  }

  public static getInstance(): FeedbackService {
    if (!FeedbackService.instance) {
      FeedbackService.instance = new FeedbackService();
    }
    return FeedbackService.instance;
  }

  private getCoreBaseUrl(): string {
    return getApiConfig().core;
  }

  public async submitFeedback(payload: FeedbackPayload): Promise<void> {
    return this.post("/feedback", payload, this.getCoreBaseUrl());
  }
}
